import React from 'react';
import {View} from 'react-native';
import moment from 'moment';

import sy from '~/styles';

import {attachment as attachmentApi} from '~/api';

import {
  Text,
  LessorPersona,
  DealerPersona,
  Thumbnail,
  Link,
} from '~/components/controls';

import DocsIcon from '~/images/md-icons/docs/materialsymbolsoutlined/24px.svg';

const Message = (props) => {
  const {
    style,
    content,
    attachments,
    timestamp: message_timestamp,
    message_id,
    rob_request_id,
    dealer_id,
    dealer_name,
    company_name,
    lessor,
    user_name,
  } = props;

  let duration;
  if (message_timestamp) {
    const timestamp = moment(message_timestamp);
    if (timestamp.isSame(moment(), 'day')) {
      duration = timestamp.format('H:mm');
    } else {
      duration = timestamp.format('D MMMM YYYY');
    }
  }

  const lessor_style = [sy['bg-tertiary-brown'], sy['ml-12']];
  const dealer_style = [sy['bg-white'], sy['mr-12']];

  return (
    <View
      style={[
        ...(dealer_name ? dealer_style : lessor_style),
        sy['overflow-hidden'],
        style,
      ]}>
      <View style={[sy['flex-1']]}>
        <View style={[sy['flex-1'], sy['flex-row'], sy['justify-between']]}>
          <View style={[sy['p-2']]}>
            <div data-private>
              <Text style={[sy.mediumBold, {lineHeight: 16}]}>
                {user_name ?? dealer_name ?? lessor}
              </Text>
            </div>
          </View>
          {dealer_name ? (
            <DealerPersona
              dealer_id={dealer_id}
              company_name={company_name}
              size={24}
            />
          ) : (
            <LessorPersona lessor={lessor} size={24} />
          )}
        </View>
        <View style={[sy['px-2']]}>
          <Text style={sy.smallRegular}>{content}</Text>
          {attachments?.length > 0 && (
            <>
              {attachments?.map((item, index) => {
                if (item.is_image) {
                  return (
                    <React.Fragment key={index}>
                      <Thumbnail
                        rob_request_id={rob_request_id}
                        message_id={message_id}
                        index={index}
                        data={item.data}
                      />
                    </React.Fragment>
                  );
                } else {
                  return (
                    <View
                      key={index}
                      style={[sy['flex-row'], sy['items-center'], sy['gap-2']]}>
                      <View style={[sy['shrink-0']]}>
                        <DocsIcon width={24} height={24} fill="#4a4a49" />
                      </View>
                      <Link
                        onPress={async () => {
                          const w = window.open();
                          w.document.write(
                            `<html style="margin: 0; padding: 0; overflow: auto; height: 100%; width: 100%; background-color: #f2f2f2;">
                                <body style="margin: 0; padding: 0; overflow: auto; height: 100%; width: 100%; background-color: #f2f2f2;">
                                  <div onclick="window.close();" style='position: absolute;background-color: #fff; padding: 4px;'><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></div>
                                  <div style='text-align: center; margin-top: 200px;'>Bezig met laden...</div>
                                </body>
                            </html>`,
                          );

                          const result =
                            (await attachmentApi.retrieve(
                              rob_request_id,
                              message_id,
                              index,
                            )) ?? {};

                          if (!result) {
                            w.document.body.innerHTML = `
                              <div onclick="window.close();" style='position: absolute;background-color: #fff; padding: 4px;'><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></div>
                              <div style='text-align: center; margin-top: 200px;'>Document laden is mislukt. Probeer het opnieuw.</div>
                            `;
                            w.document.close();

                            setTimeout(() => {
                              w.close();
                            }, 2000);
                            return;
                          }

                          w.document.body.innerHTML = `
                            <div onclick="window.close();" style='position: absolute;background-color: #fff; padding: 4px;'><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></div>
                            <iframe id="viewer" width="100%" height="100%" />
                          `;

                          const script = w.document.createElement('script');
                          script.text = `
                              const byteArray = Uint8Array.from(atob('${
                                result.split('base64,')[1]
                              }'), c => c.charCodeAt(0));
                              const blob = new Blob([byteArray], { type: 'application/pdf' });

                              const viewer = document.getElementById('viewer');
                              const objectUrl = URL.createObjectURL(blob);

                              viewer.setAttribute('src', objectUrl);
                              viewer.onload = () => URL.revokeObjectURL(objectUrl);
                          `;

                          w.document.body.appendChild(script);

                          w.document.close();
                        }}
                        style={[sy['flex-1']]}
                        textStyle={[sy['truncate']]}>
                        {item.name.substring(0, item.name.indexOf('.'))}
                      </Link>
                    </View>
                  );
                }
              })}
            </>
          )}
        </View>
      </View>
      <View
        style={[
          sy['flex-row'],
          sy['items-center'],
          sy['justify-end'],
          sy['gap-1'],
        ]}>
        <Text style={[sy.small, {lineHeight: 14}]}>{duration}</Text>
        {dealer_name ? <></> : <Text style={{width: 14}}>&nbsp;</Text>}
      </View>
    </View>
  );
};

export default Message;
